import { render } from "./FooterComp.vue?vue&type=template&id=776a7b14&scoped=true"
import script from "./FooterComp.vue?vue&type=script&lang=js"
export * from "./FooterComp.vue?vue&type=script&lang=js"

import "./FooterComp.vue?vue&type=style&index=0&id=776a7b14&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-776a7b14"]])

export default __exports__